(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsClickSignController', reports);

  reports.$inject = ['$scope', '$http', '$rootScope', 'NotificationService', 'CommandProcessorStatusService', 'SectorService'];

  function reports ($scope, $http, $rootScope, NotificationService, CommandProcessorStatusService, SectorService) {
    	var vm = this;
    	$scope.vm = vm;

    vm.loading = false;

    vm.exportAs = 'csv';

    vm.status = [];

    vm.sectors = [];

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    if ($rootScope.checkMenuAccess('reports.clickSign.showAllSectors')) {
      CommandProcessorStatusService
        .getCommandProcessorStatusByName({
          'command_processor': 'DigitalSignature'
        })
        .$promise
        .then(function (data) {
          angular.forEach(data.status, function (status, key) {
            vm.status[status.name] = status;
          });
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Ocorreu um erro ao buscar status');
        });

      SectorService.sectors_with_trashed()
        .$promise
        .then(function (data) {
          vm.sectors = data;
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao carregar Setores.');
        });
    }

    vm.download = function () {
      vm.loading = true;
      $http.get(apiUrl + '/reports/click_sign', {
        params: {
          filters: vm.filters,
          exportAs: vm.exportAs,
          statusSelected: vm.statusSelected,
          sectorSelected: vm.sectorSelected }
      })
        .then(function ({ data, status, headers, config }) {
          vm.loading = false;
          if (data.success === false) {
            NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
            return;
          }

          if (data.indexOf('sem_registros') >= 0) {
            NotificationService.errorHandler(data, 'Sem dados neste período.');
            return;
          }

          if (data) {
            var filename = headers('Mktzap-Filename') || 'click_sign.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data], { type: headers('Content-type') });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
          } else {
            NotificationService.errorHandler(data, 'Sem dados neste período.');
          }
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
        })
    };
  }
})();
